export default "__VITE_ASSET__6VaDWsb$__"